import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ProgressBar.css';
import './App.css';
import Header from './Header';
import Footer from './Footer';

const STEP_ROUTES = [
  '/client-info',
  '/company-info',
  '/quote-form',
  '/confirmation',
];

const SharedLayout = ({ children, currentStep, steps }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const getPageTitle = () => {
    const pathToTitle = {
      '/client-info': "Informations Client",
      '/company-info': "Informations Entreprise",
      '/quote-form': "Formulaire de Devis",
      '/confirmation': "Confirmation"
    };
    return pathToTitle[location.pathname] || "";
  };

  const currentPageTitle = getPageTitle();
  const totalSteps = steps ? steps.length : 0;
  const progress = totalSteps > 0 ? ((currentStep + 1) / totalSteps) * 100 : 0;

  const handleStepClick = (index) => {
    if (index < currentStep && STEP_ROUTES[index]) {
      navigate(STEP_ROUTES[index]);
    }
  };

  return (
    <div className="shared-layout flex flex-col min-h-screen">
      <Header />
      {steps && steps.length > 0 && (
        <div style={{ margin: '20px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div className="progress-bar">
            <ul className="steps-list">
              {steps.map((step, index) => {
                const isCompleted = index < currentStep;
                const isActive = index === currentStep;
                return (
                  <li
                    key={index}
                    className={`step ${isCompleted ? 'completed' : ''} ${isActive ? 'active' : ''}`}
                    onClick={() => handleStepClick(index)}
                    style={{ cursor: isCompleted ? 'pointer' : 'default' }}
                    title={isCompleted ? `Retour à : ${step}` : undefined}
                  >
                    <div className="step-number">{index + 1}</div>
                    <div className="step-label">{step}</div>
                  </li>
                );
              })}
            </ul>
            <div className="progress-line" style={{ width: `${progress}%` }} />
          </div>
        </div>
      )}
      <h2 className="text-2xl font-bold mb-4 text-center">{currentPageTitle}</h2>
      <main className="main-content flex-grow bg-gray-100 p-6">
        <div className={`form-card mx-auto bg-white rounded-lg shadow-lg p-6 ${location.pathname === '/quote-form' ? 'quote-form-wrapper' : 'max-w-3xl'}`}>
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SharedLayout;